import { useFormikContext } from 'formik'
import { Button, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'

import { EAccountSubscriptionPlans, IAccountSubcriptionPricesForm } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from '../styles'
import { useState } from 'react'
import { SubscriptionPricesInput } from './prices-input.component'
import { useOptionalSubscriptionPrices } from 'src/hooks'

export const FormInner = () => {
  const [opts, setOpts] = useState<{ months: 1 | 12; type: EAccountSubscriptionPlans }>({
    type: EAccountSubscriptionPlans.plus,
    months: 1,
  })
  const { data: prices, isLoading } = useOptionalSubscriptionPrices(opts)
  const { errors, values, isSubmitting, dirty } = useFormikContext<IAccountSubcriptionPricesForm>()
  const classes = useStyles()

  const handleSubscriptionChange = (_: any, newSubscription: EAccountSubscriptionPlans) => {
    if (newSubscription !== null) {
      setOpts({ type: newSubscription, months: 1 })
    }
  }

  const handleMonthsChange = (_: any, newMonths: 1 | 12) => {
    if (newMonths !== null) {
      setOpts((prev) => ({ ...prev, months: newMonths }))
    }
  }

  const priceName = getPriceName(opts.type, opts.months)
  const price = values[priceName]
  const error = errors[priceName]

  return (
    <div className={`${classes.formWrapper} ${classes.formWrapperWithHeight}`}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="account-prices-form-title" />
        </Typography>
        <div className={classes.inputsWrapper}>
          <div className={classes.itemWrapper}>
            <Typography className={classes.itemTitle}>
              <HelperWrapper t="subscribe-form-duration" />
            </Typography>
            <ToggleButtonGroup
              color="primary"
              exclusive
              value={opts.months}
              onChange={handleMonthsChange}
            >
              <ToggleButton value={1}>
                1&nbsp;
                <HelperWrapper t="subscription-month-text" />
              </ToggleButton>
              <ToggleButton value={12}>
                12&nbsp;
                <HelperWrapper t="subscription-months-text" />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div className={classes.itemWrapper}>
            <Typography className={classes.itemTitle}>
              <HelperWrapper t="subscribe-form-plan" />
            </Typography>
            <ToggleButtonGroup
              color="primary"
              exclusive
              value={opts.type}
              onChange={handleSubscriptionChange}
            >
              <ToggleButton value={EAccountSubscriptionPlans.plus}>Plus</ToggleButton>
              <ToggleButton value={EAccountSubscriptionPlans.premium}>Premium</ToggleButton>
            </ToggleButtonGroup>
          </div>

          <SubscriptionPricesInput
            error={error}
            value={price}
            name={priceName}
            items={prices || []}
            isLoading={isLoading}
          />
        </div>
      </div>
      <Button variant="contained" disabled={isSubmitting || !dirty} type="submit">
        <HelperWrapper t="save-button-text" />
      </Button>
    </div>
  )
}

function getPriceName(
  type: EAccountSubscriptionPlans,
  months: 1 | 12,
): keyof IAccountSubcriptionPricesForm {
  return `${type as 'plus' | 'premium'}_${months}m`
}
